import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import axios from "axios";
import styled from "styled-components";
import Chip from "@mui/material/Chip";
import DataTable from "react-data-table-component";
import useEntitesTable from "./useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import Tooltip from "@mui/material/Tooltip";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { makeStyles, withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import { usage } from "variables/patrimoine.js";
import { categoryData, energyData } from "variables/lists/usage.js";
import { getSite, getFiles, downloadFile } from "services/ConfigServices";
import Edit from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import UsageDialog from "./UsageDialog";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementDataClickable = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;

const UsageList = (props) => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { parameters } = props;
  const {
    gridState,
    refetch,
    handleClose,
    usageList,
  } = useEntitesTable();
  const [deleteCounter, setDeleteCounter] = useState(0);
  const [open, setOpen] = useState(false);
  const [prevEquipList, setPrevEquipList] = useState();
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [currentUsage, setCurrentUsage] = useState('');

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  let dataUsages = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };
  const handleDeleteCounterChange = (e) => {
    setDeleteCounter((prevCounter) => prevCounter + 1);
  };


  const columns = [
    {
      name: usage.name,
      selector: row => row.name,
      sortable: true,
    },
    {
      name: usage.category,
      selector: row => row.category,
      sortable: true,
      cell: (row) => row.category ?
        categoryData.find((x) => x.id == row.category).name : ""

    },
    {
      name: usage.associatedmeter,
      selector: row => row.associatedmeter,
      sortable: true,
    },
    {
      name: usage.energy,
      selector: row => row.energy,
      sortable: true,
      cell: (row) => row.energy ?
        energyData.find((x) => x.id == row.energy).name : ""
    },
    {
      name: usage.iotcount,
      selector: row => row.iot,
      sortable: true,
      cell: (row) => row.points ?
        row.points.length : ""
    },
    {
      name: usage.equipmentcount,
      selector: row => row.equipments,
      sortable: true,
      cell: (row) => row.equipments ?
        row.equipments.length : ""
    },
    {
      name: usage.consumptionpart,
      selector: row => row.consumptionpart,
      sortable: true,
    },
    realestateupdate ?
      {
        name: "Actions",
        sortable: true,
        width: "8rem",
        // eslint-disable-next-line react/display-name
        cell: (row) => (
          <>
            <div className="actions-right">
              <Tooltip title="Editer l'usage">
                <Button
                  color={"success"}
                  className={classes.actionButton}
                  onClick={editUsage(row)}
                >
                  <Edit className={classes.icon} />
                </Button>
              </Tooltip>
              <Tooltip title="Supprimer l'usage">
                <CustomDeleteButton
                  deleteTitle={"Suppression de l'usage"}
                  deleteSubTitle={
                    "Êtes-vous sûr de vouloir supprimer l'usage?"
                  }
                  handleSupprimer={deleteUsage(row)}
                />
              </Tooltip>
            </div>
          </>
        ),
      } : {},
  ];

  const editUsage = (row) => async () => {
    let obj = dataUsages.find((o) => o.uuid === row.uuid);
    if (obj) {
      setCurrentUsage(obj);
      handleClickOpen();
    }
  };

  const deleteUsage = (row) => async () => {
    let obj = dataUsages.find((o) => o.uuid === row.uuid);
    const indexToDelete = dataUsages.findIndex((x) => x.uuid === obj.uuid);
    usageList.splice(indexToDelete, 1);
    axios
      .put(
        getSite(chartIdGroup, "usage.usagelist"),
        usageList,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Usage supprimé");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        refetch();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          onSelectedRowsChange={updateState}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleEditClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
            Modifier l'usage
          </DialogTitle>
          <DialogContent dividers>
            <UsageDialog
              closeModal={handleEditClose}
              refetch={refetch}
              usageList={usageList}
              currentUsage={currentUsage}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default UsageList;
